/* eslint-disable no-case-declarations */
import { DeleteAPIData, LoadAPIData, SaveAPIData } from '../../helpers/DataHelper';
import { ShowToast } from '../../helpers/Toast';
import { ColumnDirective, ColumnsDirective, CommandColumn, Edit, GridComponent, Inject, Sort, Toolbar } from '@syncfusion/ej2-react-grids';
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';
import { HtmlEditor, Image, Count, Link, Toolbar as rteToolbar, QuickToolbar, RichTextEditorComponent } from '@syncfusion/ej2-react-richtexteditor';
import { DatePickerComponent, TimePickerComponent } from '@syncfusion/ej2-react-calendars';
import { DropDownListComponent, ListBoxComponent } from '@syncfusion/ej2-react-dropdowns';
import { NumericTextBoxComponent, TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { ToastUtility } from '@syncfusion/ej2-react-notifications';
import { useEffect, useState } from 'react';
//import { confirm } from '../../helpers/Global';
import { confirm } from "react-confirm-box";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { CommandTemplate, ConfirmDialogStyles, SearchGridToolbar, SimpleToolbarSettings } from '../../helpers/Global';
import { fieldRequired } from '../../helpers/validation';


export default function FAQs() {

  const [editData, setEditData] = useState();
  const [editId, setEditId] = useState(0);

  const [title, setTitle] = useState('');
  const [copy, setCopy] = useState('');
  const [parentId, setParentId] = useState(0);
  const [type, setType] = useState(0);
  const [displayOrder, setDisplayOrder] = useState(0);
  const [dateAdded, setDateAdded] = useState(new Date());
  const [addedBy, setAddedBy] = useState(0);
  const [dateModified, setDateModified] = useState(new Date());
  const [modifiedBy, setModifiedBy] = useState(0);
  const [status, setStatus] = useState(0);
  const [sites, setSites] = useState('');

  const [editModal, setEditModal] = useState(false);

  const toggle = () => setEditModal(!editModal);


  const commandClick = async (args) => {
    switch (args.commandColumn.type) {
      case 'Delete':
        //if (await confirm({ confirmation: 'Are you sure you want to delete this item?' })) {
        if (await confirm("Are you sure you want to delete this item?", ConfirmDialogStyles)) {
          deleteItem(args.rowData.id);
        }
        break;
      default: //edit
        editItem(args.rowData.id);
        break;
    }
  }

  const loadData = async () => {
    setEditData(await LoadAPIData('/api/faqs'));
  }

  const addItem = () => { editItem(0); }

  const editItem = (id) => {
    if (id > 0) {
      const data = editData.find((item) => { return item.id === id });
      setEditId(data.id);
      
      setTitle(data.title);
      setCopy(data.copy);
      setParentId(data.parentId);
      setType(data.type);
      setDisplayOrder(data.displayOrder);
      setDateAdded(data.dateAdded);
      setAddedBy(data.addedBy);
      setDateModified(data.dateModified);
      setModifiedBy(data.modifiedBy);
      setStatus(data.status);
      setSites(data.sites);

    }
    else {
      //clear state fields
      setEditId(0);

      setTitle('');
      setCopy('');
      setParentId(0);
      setType(0);
      setDisplayOrder(0);
      setDateAdded(null);
      setAddedBy(0);
      setDateModified(null);
      setModifiedBy(0);
      setStatus(0);
      setSites('');

    }
    setEditModal(true);
  };

  const validateForm = () => {
    var valid = true;

    return valid;
  }

  const saveItem = async (event) => {
    event.stopPropagation();

    if (validateForm()) {
      const data = { id: editId, title: title, copy: copy, parentId: parentId, type: type, displayOrder: displayOrder, dateAdded: dateAdded, addedBy: addedBy, dateModified: dateModified, modifiedBy: modifiedBy, status: status, sites: sites, };

      const result = await SaveAPIData('/api/faqs', data, (editId === 0 ? 'POST' : 'PUT'));
      if (result.success) {
        loadData();
        ShowToast('FAQs', 'The faqs was successfully saved!', 'toast-success');
      }
      else {
        ShowToast('FAQs', 'There was an error saving the faqs!', 'toast-danger');
      }
      toggle();
    }
  }

  const deleteItem = async (dataId) => {
    const result = await DeleteAPIData('/api/faqs/' + dataId)
    if (result) {
      loadData();
      ShowToast('FAQs', 'The faqs was successfully deleted!', 'toast-success');
    }
    else {
      ShowToast('FAQs', 'There was an error deleting the faqs!', 'toast-danger');
    }
  }


  useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-6 "><h1>FAQs</h1></div>
        <div className="col-md-6 text-end align-self-center">
          <Button color="primary" size="sm" onClick={addItem}>Add New <i className="fas fa-plus-circle ms-2"></i></Button>
        </div>
      </div>

      <GridComponent dataSource={editData?.filter(p => p.type === 2)} allowSorting={true} toolbar={SearchGridToolbar} commandClick={commandClick} >
        <ColumnsDirective>
          <ColumnDirective field='ParentId' width='50' headerText="Group" />
          <ColumnDirective field='Title' width='100' headerText="Question" />
          <ColumnDirective field='Sites' width='50' headerText="Sites" />
          <ColumnDirective headerText='Actions' width='20' commands={CommandTemplate} />
        </ColumnsDirective>
        <Inject services={[Sort, Edit, CommandColumn, Toolbar]} />
      </GridComponent>

      <Modal isOpen={editModal} toggle={toggle} scrollable size="lg" backdrop="static">
        <ModalHeader toggle={toggle}>{editId === 0 ? "Add New" : "Edit"} FAQs</ModalHeader>
        <ModalBody>
          <div className='mb-3'>
            <label htmlFor='tbTitle'>Question</label>
            <RichTextEditorComponent id='tbTitle' name='tbTitle' placeholder='Title' toolbarSettings={SimpleToolbarSettings} showCharCount={true} value={title} change={e => setTitle(e.value)} >
              <Inject services={[rteToolbar, HtmlEditor, QuickToolbar, Count]} />
            </RichTextEditorComponent>
            <div id='tbTitleError' className='error-message' />
          </div>

          <div className='mb-3'>
            <label htmlFor='tbCopy'>Answer</label>
            <RichTextEditorComponent id='tbCopy' name='tbCopy' placeholder='Copy' toolbarSettings={SimpleToolbarSettings} showCharCount={true} value={copy} change={e => setCopy(e.value)} >
              <Inject services={[rteToolbar, HtmlEditor, QuickToolbar, Count]} />
            </RichTextEditorComponent>
            <div id='tbCopyError' className='error-message' />
          </div>

          <div className='mb-3'>
            <DropDownListComponent id='ddParentId' name='ddParentId' placeholder='Question Group' floatLabelType='Auto' showClearButton={true} value={parentId} onChange={e => setParentId(e.value)} />
            <div id='ddParentIdError' className='error-message' />
          </div>

          {/*<div className='mb-3'>*/}
          {/*  <NumericTextBoxComponent id='tbType' name='tbType' placeholder='Type' floatLabelType='Auto' showClearButton={true} value={type} onChange={e => setType(e.value)} />*/}
          {/*  <div id='tbTypeError' className='error-message' />*/}
          {/*</div>*/}

          {/*<div className='mb-3'>*/}
          {/*  <NumericTextBoxComponent id='tbDisplayOrder' name='tbDisplayOrder' placeholder='Display Order' floatLabelType='Auto' showClearButton={true} value={displayOrder} onChange={e => setDisplayOrder(e.value)} />*/}
          {/*  <div id='tbDisplayOrderError' className='error-message' />*/}
          {/*</div>*/}

          <div className='mb-3'>
            <TextBoxComponent id='tbSites' name='tbSites' placeholder='Sites' type='text' maxLength='250' floatLabelType='Auto' showClearButton={true} value={sites} onChange={e => setSites(e.value)} />
            <div id='tbSitesError' className='error-message' />
          </div>


        </ModalBody>
        <ModalFooter>
          <Button color="dark" size="sm" onClick={toggle}>Cancel <i className="far fa-times-circle ms-2"></i></Button>
          <Button color="success" size="sm" onClick={saveItem}>Save <i className="far fa-check-circle ms-2"></i></Button>
        </ModalFooter>
      </Modal>

    </>
  );
}

